import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { Product } from "../models/product";
import { ConfigService } from "./config.service";
import { TableGroup } from "../models/tablegroup";
import { ProductSubCategory } from "../models/productsubcategory";
import { LanguageService } from "./language.service";

interface QuestionDetailResult {
  questionId: string;
  answerId: string;
  price: number;
  productId: string;
  description: string;
  type: string;
}

@Injectable({
  providedIn: "root",
})
export class ProductService {
  products: ProductSubCategory[];

  private http = inject(HttpClient);
  private configService = inject(ConfigService);

  public getAllTables() {
    return this.http
      .get<{ data: TableGroup[] }>(this.configService.getApiUrl() + "/tables/")
      .pipe(
        map((response) => {
          return response.data.filter((item) => {
            return item.id != "";
          });
        }),
      );
  }

  public getAllCategoriesAndProducts(): Observable<ProductSubCategory[]> {
    const url =
      this.configService.getApiUrl() +
      "/products?orderPortalGroup=" +
      this.configService.getPlaceId() +
      "&language=" +
      LanguageService.getCurrentLanguage();

    if (!this.products) {
      return this.http.get<{ data: ProductSubCategory[] }>(url).pipe(
        map((response) => {
          this.products = response.data.filter((item) => {
            return item.id != "";
          });
          return this.products;
        }),
      );
    } else {
      return of(this.products);
    }
  }

  getProductById(productId: string, products: ProductSubCategory[]): Product {
    for (const subCategory of products) {
      for (const product of subCategory.products) {
        if (product.id == productId) {
          return product;
        }
      }
    }
  }

  getQuestionDetails(
    product: Product,
    questionId: string,
    answerId: string,
  ): QuestionDetailResult {
    const details: QuestionDetailResult = {
      questionId,
      answerId,
      price: null,
      productId: null,
      description: "",
      type: "",
    };

    for (const question of product.questions) {
      if (question.id == questionId) {
        if (question.type === "OPEN") {
          details.type = "OPEN";
          details.description = question.question + ": " + answerId;
        } else {
          for (const answer of question.answers) {
            if (answer.id == answerId) {
              details.type = "SINGLE_CHOICE";
              details.price = answer.price;
              details.productId = answer.product_id;
              details.description = question.question + ": " + answer.answer;
            }
          }
        }
      }
    }
    return details;
  }
}
